export const UNDEFINED = 'UNDEFINED';
export const CNAME = 'time-picker';
export const SIZE_SM = 'sm';
export const SIZE_LG = 'lg';
